<section class="hero">
  <div class="hero-content">
    <h1 class="h1-lg-blue font-500">{{ 'home.welcome.title' | translate }}</h1>
    <p class="gs1-default-size gs1-color-blue font-300">
      {{ 'home.welcome.description' | translate }}
    </p>
  </div>
  <div class="hero-image-container">
    <img src="assets/svg/hero_img.svg" alt="Illustration de personnes travaillant ensemble" />
  </div>
</section>
